import { IdentificationInputValue, IdentificationType } from "../IdentificationInput.types";

export interface UseIdentificationInputValueResult {
    handleTypeChange: (type: IdentificationType) => void;
    handleCodeChange: (code: string) => void;
}

export default function useIdentificationInputValue(
    value: IdentificationInputValue,
    setValue: (v: IdentificationInputValue) => void,
): UseIdentificationInputValueResult {
    const handleTypeChange = (type: IdentificationType | undefined) => {
        setValue([type, value[1]]);
    };

    const handleCodeChange = (code: string) => {
        setValue([value[0], code]);
    };

    return {
        handleTypeChange,
        handleCodeChange,
    };
}
